import React from 'react';
import classNames from 'classnames';
import BaseProps from "../../types/BaseProps";
import loader from '../../images/ot-loader.svg';
import './Loader.scss';

type LoaderProps = BaseProps & {
  title?: string
  size?: 'xs' | 'sm' | 'lg'
  block?: boolean
};

/**
 * An animated loader component that can be used to show that something is being processed.
 */
export default class Loader extends React.Component<LoaderProps> {

  public static defaultProps = {
    size: 'sm',
    block: false
  };

  render() {
    if (this.props.block) {
      return (
        <div className="LoaderBlock text-center">
          <LoaderImage {...this.props} />
        </div>
      );
    }
    return (
      <LoaderImage {...this.props} />
    );
  }
}

function LoaderImage(props: LoaderProps) {
  return (
    <img className={classNames('Loader', props.className, props.size)}
         alt={props.title}
         src={loader}/>
  );
}
